import { useState } from 'react';
import type { StoryElement } from '../types';
import { toggleStoryBookmark } from '../utils/toggleStoryBookmark';
import { BookmarkToggleButton } from './BookmarkToggleButton';

interface StoryBookmarkButtonProps {
  story: Pick<StoryElement, 'id' | 'is_flagged'>;
  onStoryUpdate?: () => void;
}

export function StoryBookmarkButton({ story, onStoryUpdate }: StoryBookmarkButtonProps) {
  const [, bumpRender] = useState(0);
  const notifyUpdate = onStoryUpdate ?? (() => bumpRender((n) => n + 1));

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    void toggleStoryBookmark(story, notifyUpdate);
  };

  return (
    <BookmarkToggleButton isFlagged={story.is_flagged} onClick={handleClick} />
  );
}
